import generateBootFunc from '@core/generate-boot';
import Index from './Components/Index.vue';
import { validateScheme } from "@modules/Operator/util";

const bootIndex = generateBootFunc(Index, 'operator-test');

export {
    bootIndex,
    validateScheme
};